import {Component, Input, OnInit} from '@angular/core';
import {MarketProduct} from '@app/marketplace/products/_models/product.interface';
import {TrackingComponent} from '@app/shared/components/tracking/tracking.component';
import {ProductService} from '@app/marketplace/products/_services/product.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {PushToCartComponent} from '@app/marketplace/shared/_components/push-cart.component';
import {finalize} from 'rxjs/operators';
import {ViewTypeEnum} from '@app/marketplace/core/enum/viewTypeEnum';
import {ProductDetailsDlgComponent} from '@app/marketplace/products/product-details-dlg/product-details-dlg.component';

@Component({
  selector: 'app-most-popular-products',
  templateUrl: './most-popular-products.component.html',
  styleUrls: ['./most-popular-products.component.css']
})
export class MostPopularProductsComponent extends PushToCartComponent implements OnInit {

  @Input()
  title: string;
  @Input()
  term: string;

  products: MarketProduct[] = [];
  payload: any;
  loading$: boolean;

  theme = { 'min-width': '220px', 'min-height': '219px', background: '#f1f1f1' };

  constructor(private productService: ProductService,
              private modalService: NgbModal,
              private router: Router,
              private store: Store<any>) {
    super(null, null,  null, null);
    this.payload = {
      pageIndex: 1,
      pageSize: 4,
      pagingStrategy: 0,
      locationType: 0,
      locations: null,
      locationResolver: false,
      filter: {
        searchTerms: 'electrodomésticos',
      },
      provider: 3,
      categoryCode: '',
      supplierCode: '',
    };
  }

  ngOnInit(): void {
    if (this.term) {
      this.payload.filter.searchTerms = this.term;
    }
    this.getProducts();
  }
  getProducts() {
    this.loading$ = true;
    this.productService.ListProducts(this.payload).pipe(finalize(() => this.loading$ = false)).subscribe((result: any) => {
      if (result && result.data) {
        result.data.map(data => {
          data.ratingsCounter = new Array(Number(data.rating.toFixed(0)));
        });
        this.products = result.data.filter(x => x.price > 0).slice(0, 4);
      }
    });
  }

  public pushToCart(product: any, tab) {
    const itemImg = $(`#${tab}-${product.code}`).find('img').eq(0);
    this.flyToElement($(itemImg), product, ViewTypeEnum.ProductList, this.store);
  }

  shortText(text: string) {
    if (text.length > 50) {
      return text.slice(0, 50) + '...';
    }
  }

  openDetails(product: any) {
    const modalRef = this.modalService.open(ProductDetailsDlgComponent, {size: 'xl', modalDialogClass: 'book-address'});
    modalRef.componentInstance.code = product.code;
    modalRef.componentInstance.provider = product.productProvider;
    modalRef.componentInstance.origin = 'home';
    modalRef.result.then(
      (result: boolean) => {
        if (result) {
          this.router.navigate([`/market/productos-compras-cuba-online/walmart/${product.code}`]);
        }
      },  () => {}
    );
  }

}
